import { useQuery } from "@tanstack/react-query";
import { apiInstance } from "../utils/_apiInstance";

interface GetAuthorsProps {
  search: string;
  enabled?: boolean;
}

interface Response {
  results: string[];
}

export const getAuthors = async ({ search }: GetAuthorsProps) => {
  const response = await apiInstance.get<Response>("filtros/autores", {
    params: {
      q: search,
    },
  });
  return response.data;
};

export const useAuthorsQuery = (props: GetAuthorsProps) =>
  useQuery({
    queryKey: ["get-authors", props.search?.toLowerCase()],
    queryFn: () => getAuthors(props),
    enabled: props.search.length >= 3 && !!props.enabled,
  });
